import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

let appBody = document.getElementsByTagName('body')
let scriptTag = document.createElement('script')

if (environment.production) {
  enableProdMode()
  scriptTag.src = "https://js.authorize.net/v1/Accept.js"
  appBody[0].appendChild(scriptTag)
}  else {
  scriptTag.src = "https://jstest.authorize.net/v1/Accept.js"
  appBody[0].appendChild(scriptTag)
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
